import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PwaManifestService } from '@madeinlune/ngx-pwa-manifest';
import { map, Observable } from 'rxjs';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { TranslocoModule } from '@ngneat/transloco';
import { MenuItemContext } from '@nx-icilalune/data/icilalune/types';
import { LetModule } from '@ngrx/component';

export interface AlertAction {
  label: string;
  id: string;
  close?: boolean;
  emitter?: EventEmitter<any>;
  main?: boolean;
}

export interface AlertDialogData {
  title?: string;
  message: string;
  details?: string;
  actions?: AlertAction[];
  color?: MenuItemContext;
}

export interface RgpdDialogData extends AlertDialogData {
  link?: string;
}

@Component({
  selector: 'nx-icilalune-alert',
  template: `
    <div class="b-icon">
      <ng-container *ngrxLet="iconUrl$; let iconUrl">
        <ng-container *ngIf="iconUrl">
          <img [src]="iconUrl" />
        </ng-container>
      </ng-container>
    </div>

    <ng-container *transloco="let t">
      <div class="b-content">
        <p [innerHTML]="t(data.message)" class="message"></p>

        <ng-container *ngIf="data.details as details">
          <small [innerHTML]="details" class="details"></small>
        </ng-container>

        <div class="b-actions">
          <ng-template ngFor [ngForOf]="data.actions" let-action>
            <button
              class="lune-btn"
              [class.filled]="action.main"
              (click)="onActionClick(action)"
            >
              <span [innerHTML]="t(action.label)"></span>
            </button>
          </ng-template>
        </div>
      </div>
    </ng-container>
  `,
  styleUrls: ['./alert.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  iconUrl$: Observable<string | undefined> =
    this.pwaManifestService.icons$.pipe(
      map((icons) => {
        return icons.find((icon) => icon.sizes === '192x192')?.src;
      })
    );

  constructor(
    @Inject(DIALOG_DATA) public data: AlertDialogData,
    private dialogRef: DialogRef<AlertAction>,
    private pwaManifestService: PwaManifestService
  ) {}

  onActionClick(action: AlertAction) {
    this.dialogRef.close(action);
  }
}

@NgModule({
  imports: [CommonModule, TranslocoModule, LetModule],
  declarations: [AlertComponent],
  exports: [AlertComponent],
})
export class AlertComponentModule {}
